import { render, staticRenderFns } from "./base-collapse.vue?vue&type=template&id=6262b1e2&"
import script from "./base-collapse.vue?vue&type=script&lang=js&"
export * from "./base-collapse.vue?vue&type=script&lang=js&"
import style0 from "./base-collapse.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports